import React, { useState, useEffect } from "react";

function AgencyAchivements() {
  const [description, setDescription] = useState("");
  const [agencyId, setAgencyId] = useState('');
  const [achievements, setAchievements] = useState([]);

  useEffect(() => {
    const storedEmail = localStorage.getItem('Agencyid');
    if (storedEmail) {
      setAgencyId(storedEmail);
      getAllAchievements(storedEmail);
    }
  }, []);






  
  const handleChange = (e) => {
    setDescription(e.target.value);
  };






  async function getAllAchievements(el) {
    const res = await fetch('https://alerting-disaster-ndf5g2xba-pratham704.vercel.app/getalltheachivements', {
      method: 'POST',
      body: JSON.stringify({ el }),
      headers: { 'Content-Type': 'application/json' },
    });

    if (res.ok) {
      const ans = await res.json();
      setAchievements(ans);
    } else {
      console.error("Error fetching achievements");
    }
  }







  async function handleSubmit(e) {
    e.preventDefault();
    console.log("Description submitted:", description);

    const res = await fetch('https://alerting-disaster-ndf5g2xba-pratham704.vercel.app/agencyachivemsnts', {
      method: 'POST',
      body: JSON.stringify({ description, agencyId }),
      headers: { 'Content-Type': 'application/json' },
    });


      const ans = await res.json();
      setAchievements(ans);;
   
  };

  return (
    <>
      <div className="agency bg-cover bg-center flex flex-col justify-start items-center">
        <div className="bg-white p-6 rounded-lg shadow-md border border-gray-300 w-full md:w-1/2 lg:w-1/3 mt-4">
          <h1 className="text-2xl font-semibold mb-4">Achivements of Agency</h1>
          <form onSubmit={handleSubmit}>
            <textarea
              className="w-full p-2 border rounded-md mb-4 shadow-inner focus:shadow-outline"
              placeholder="your new achivements"
              value={description}
              onChange={handleChange}
            ></textarea>
            <button
              type="submit"
              className="bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600 shadow-md"
            >
              Submit your achievements
            </button>
          </form>
        </div>
      </div>
      <br />
      <br />
{achievements.length > 0 ?<>

  <div className="earthquake-info-container">
        {achievements.map((achievement) => (
          <div key={achievement._id} className="  earthquake-info-box2 cursor-pointer">
            <p>{achievement.Achievements}</p>
      
          </div>
        ))}
      </div>





</>:<></>}
      {/* Map over and display achievements */}
     



    </>
  );
}

export default AgencyAchivements;
